import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormikContext, useField } from "formik";
import { constants } from "@qgiv/core-js";
import { ManualEmployerMatching } from "@qgiv/core-donor";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectRegistrationTotals } from "../../../redux/slices/registrationSlice";
import { selectCmsControlByType } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";

const ConnectedManualEmployerMatching = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_MATCHING_GIFT },
        },
    } = constants;

    const isCms = useSelector(selectIsCms);
    const totals = useSelector(selectRegistrationTotals);
    const { optionalDonationAmount } = totals;
    const { path, currency, enableMatching } = useSelector(
        selectAllFormSettings,
    );

    const { options } = useSelector((state) =>
        selectCmsControlByType(P2P_MATCHING_GIFT, state),
    );
    const { enableOptionalDonation } = useSelector(selectAllP2pSettings);

    const {
        sectionHeading = "Your gift could be worth more!",
        description = "Find out if you’re eligible for a matching gift from your employer.",
        manualMatchingLabel = "This gift can be matched",
        manualMatchingHelpText = "",
        manualMatchingCompanyLabel = "Matching Company",
        manualMatchingAmountLabel = "Matching Amount",
        teaserLabel = "Your gift could be worth more with a matching gift from your employer!",
    } = options;

    const { values, setValues } = useFormikContext();
    const { Match_Gift, Employer, Donation_Amount } = values;
    const [{ onBlur, onChange, ...field }] = useField({
        name: "Match_Gift",
        type: "checkbox",
    });
    const fieldProps = {
        ...field,
        id: "Match_Gift",
        name: "Match_Gift",
        handleChange: onChange,
        handleBlur: onBlur,
    };

    const employerField = Employer;
    const displayMatchingGift = enableMatching && enableOptionalDonation;
    const donationTotal = optionalDonationAmount;
    const hasMatchableDonation = donationTotal > 0 || isCms;
    const isVisible = (!!Match_Gift && donationTotal > 0) || isCms;

    // Prevent Manual Match checkbox from being checked if no Optional Donations
    useEffect(() => {
        if (!Donation_Amount) {
            setValues({
                ...values,
                Match_Gift: false,
                Employer: "",
                Matching_Gift_Amount: "",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Donation_Amount, setValues]);

    const matchingGiftProps = {
        currency,
        employerField,
        hasMatchableDonation,
        isStandardDonationForm: true,
        isVisible,
        sectionHeading,
        description,
        manualMatchingAmountLabel,
        manualMatchingCompanyLabel,
        manualMatchingHelpText,
        manualMatchingLabel,
        Match_Gift,
        path,
        teaserLabel,
        values,
        setValues,
        fieldProps,
    };

    return displayMatchingGift ? (
        <ManualEmployerMatching {...matchingGiftProps} />
    ) : null;
};

ConnectedManualEmployerMatching.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedManualEmployerMatching;
